var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.98 8.71992C12.82 10.4999 11.5333 11.6666 9.66668 11.6666H3.66668C1.82668 11.6666 0.333344 10.1733 0.333344 8.33325V3.66658C0.333344 1.85325 1.42668 0.586585 3.12668 0.373252C3.30001 0.346585 3.48001 0.333252 3.66668 0.333252H9.66668C9.84001 0.333252 10.0067 0.339919 10.1667 0.366585C11.76 0.553252 12.84 1.66659 12.98 3.27992C13 3.47325 12.84 3.63325 12.6467 3.63325H11.6133C10.9733 3.63325 10.38 3.87992 9.95334 4.31992C9.44668 4.81325 9.19334 5.50659 9.25334 6.19992C9.36001 7.41325 10.4267 8.36658 11.6933 8.36658H12.6467C12.84 8.36658 13 8.52658 12.98 8.71992Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentTransactions);
export default __webpack_public_path__ + "static/media/recent-transactions.0085eb8b8d505d86a6cfdddd73d53216.svg";
export { ForwardRef as ReactComponent };